import { defineAsyncComponent } from 'vue';
import SelectAppLanguage from '../components/inputs/SelectAppLanguage.vue';
import SelectAppCurrency from '../components/inputs/SelectAppCurrency.vue';

import VignettePrices from '../components/VignettePrices.vue';

const GetProducts = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'get-products' */ '../components/inputs/GetProducts.vue')
);

const BuyVignette = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'buy-vignette' */ '../components/BuyVignette/BuyVignette.vue')
);
const PaymentProcessing = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'payment-processing' */ '../components/PaymentProcessing.vue')
);

import LazyMapPopup from '../components/LazyMapPopup.vue';
import WhenNearViewport from '../components/WhenNearViewport.vue';
import MobileHeader from '../components/MobileHeader.vue';
import HeaderLanguageSelector from '../components/HeaderLanguageSelector.vue';
import MaterialSymbol from '../components/MaterialSymbol.vue';

const ShoppingCart = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'shopping-cart' */ '../components/ShoppingCart.vue')
);
const PricingSection = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'pricing-section' */ '../components/PricingSection.vue')
);
const PricingSectionHero2 = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'pricing-section-hero2' */ '../components/PricingSectionHero2.vue')
);
const ContactLanguages = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'contact-languages' */ '../components/ContactLanguages.vue')
);
const PaymentMethodsPills = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'payment-methods-pills' */ '../components/PaymentMethodsPills.vue')
);
const PaymentMethodsCountrySelect = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'payment-methods-country-select' */ '../components/PaymentMethodsCountrySelect.vue')
);
const PaymentMethodsGrid = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'payment-methods-grid' */ '../components/PaymentMethodsGrid.vue')
);
const PaymentMethodsReadyPrices = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'payment-methods-ready-prices' */ '../components/PaymentMethodsReadyPrices.vue')
);
const LanguageSelectorBlock = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'language-selector-block' */ '../components/LanguageSelectorBlock.vue')
);
const WhyChooseUsLanguageDropdown = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'why-choose-us-language' */ '../components/WhyChooseUsLanguageDropdown.vue')
);
const ValidityCheck = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'validity-check' */ '../components/ValidityCheck.vue')
);
const HowItWorksValidityCheckTeaser = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'howitworks-validity-teaser' */ '../components/HowItWorksValidityCheckTeaser.vue')
);
const EuropeMap = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'europe-map' */ '../components/EuropeMap.vue')
);
const Team4Flags = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'team4-flags' */ '../components/Team4Flags.vue')
);
const HomeLicensePlateSearch = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'home-license-plate-search' */ '../components/HomeLicensePlateSearch.vue')
);
const HomeGuidesSection = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'home-guides-section' */ '../components/HomeGuidesSection.vue')
);
const BlogCategoryFilters = defineAsyncComponent(() =>
    import(/* webpackChunkName: 'blog-category-filters' */ '../components/BlogCategoryFilters.vue')
);

export {
    BuyVignette,
    PaymentProcessing,
    ShoppingCart,
    PricingSection,
    PricingSectionHero2,
    LazyMapPopup as MapPopup,
    MobileHeader,
    HeaderLanguageSelector,
    HowItWorksValidityCheckTeaser,
    MaterialSymbol,
};

/** Resolved on #app root only (Blade uses them inside the main mount point). */
export function getRootAppComponents() {
    return {
        SelectAppLanguage,
        SelectAppCurrency,
        GetProducts,
        VignettePrices,
        BuyVignette,
        PaymentProcessing,
    };
}

/**
 * @param {import('vue').App} app
 */
export function registerGlobalComponents(app) {
    app.component('select-app-currency', SelectAppCurrency);
    app.component('SelectAppCurrency', SelectAppCurrency);
    app.component('select-app-language', SelectAppLanguage);
    app.component('SelectAppLanguage', SelectAppLanguage);
    app.component('payment-processing', PaymentProcessing);
    app.component('shopping-cart', ShoppingCart);
    app.component('PricingSection', PricingSection);
    app.component('PricingSectionHero2', PricingSectionHero2);
    app.component('MapPopup', LazyMapPopup);
    app.component('map-popup', LazyMapPopup);
    app.component('MobileHeader', MobileHeader);
    app.component('mobile-header', MobileHeader);
    app.component('HeaderLanguageSelector', HeaderLanguageSelector);
    app.component('header-language-selector', HeaderLanguageSelector);
    app.component('HowItWorksValidityCheckTeaser', HowItWorksValidityCheckTeaser);
    app.component('how-it-works-validity-check-teaser', HowItWorksValidityCheckTeaser);
    app.component('ValidityCheck', ValidityCheck);
    app.component('validity-check', ValidityCheck);
    app.component('ContactLanguages', ContactLanguages);
    app.component('contact-languages', ContactLanguages);
    app.component('PaymentMethodsPills', PaymentMethodsPills);
    app.component('payment-methods-pills', PaymentMethodsPills);
    app.component('PaymentMethodsCountrySelect', PaymentMethodsCountrySelect);
    app.component('payment-methods-country-select', PaymentMethodsCountrySelect);
    app.component('PaymentMethodsGrid', PaymentMethodsGrid);
    app.component('payment-methods-grid', PaymentMethodsGrid);
    app.component('PaymentMethodsReadyPrices', PaymentMethodsReadyPrices);
    app.component('payment-methods-ready-prices', PaymentMethodsReadyPrices);
    app.component('EuropeMap', EuropeMap);
    app.component('europe-map', EuropeMap);
    app.component('LanguageSelectorBlock', LanguageSelectorBlock);
    app.component('language-selector-block', LanguageSelectorBlock);
    app.component('WhyChooseUsLanguageDropdown', WhyChooseUsLanguageDropdown);
    app.component('why-choose-us-language-dropdown', WhyChooseUsLanguageDropdown);
    app.component('Team4Flags', Team4Flags);
    app.component('team-4-flags', Team4Flags);
    app.component('HomeLicensePlateSearch', HomeLicensePlateSearch);
    app.component('home-license-plate-search', HomeLicensePlateSearch);
    app.component('WhenNearViewport', WhenNearViewport);
    app.component('when-near-viewport', WhenNearViewport);
    app.component('HomeGuidesSection', HomeGuidesSection);
    app.component('home-guides-section', HomeGuidesSection);
    app.component('BlogCategoryFilters', BlogCategoryFilters);
    app.component('blog-category-filters', BlogCategoryFilters);
    app.component('MaterialSymbol', MaterialSymbol);
    app.component('material-symbol', MaterialSymbol);
}
